import {CrewSample} from './crew';
import {AddCrewResponseEntity} from './addCrewResponseEntity';

export class EditCrewCardInfo {
  crew: CrewSample;
  crewNumbersWithCompetitors: AddCrewResponseEntity;

  constructor(
    crew = new CrewSample(),
    crewNumbersWithCompetitors = new AddCrewResponseEntity()
  ) {
    this.crew = crew;
    this.crewNumbersWithCompetitors = crewNumbersWithCompetitors;
  }
}
